
import { useState, useEffect, useRef } from "react";
import FooterView from "../footerView";
import {allProjectsList} from "../../pages/shop";

// Tailwind config extension note:
// Add to tailwind.config.js:
// theme: { extend: { fontFamily: { serif: ['"Instrument Serif"', 'Georgia', 'serif'], sans: ['"DM Sans"', 'sans-serif'] } } }
// And in index.html <head>:
// <link href="https://fonts.googleapis.com/css2?family=Instrument+Serif:ital@0;1&family=DM+Sans:opsz,wght@9..40,300;9..40,400;9..40,500&display=swap" rel="stylesheet">


const selectedService = allProjectsList.filter((item) => { return item.id === "12"})[0]
const price = selectedService.cost
const priceFormatted = `$${parseInt(price).toLocaleString('en-US')}`
console.log("This is the asdfasdf price", priceFormatted);

function useInView(options = {}) {
    const ref = useRef(null);
    const [inView, setInView] = useState(false);
    useEffect(() => {
        const el = ref.current;
        if (!el) return;
        const obs = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) { setInView(true); obs.unobserve(el); }
        }, { threshold: 0.12, ...options });
        obs.observe(el);
        return () => obs.disconnect();
    }, []);
    return [ref, inView];
}

function Reveal({ children, delay = 0, className = "" }) {
    const [ref, inView] = useInView();
    return (
        <div
            ref={ref}
            className={className}
            style={{
                opacity: inView ? 1 : 0,
                transform: inView ? "translateY(0)" : "translateY(24px)",
                transition: `opacity 0.7s ease ${delay}ms, transform 0.7s ease ${delay}ms`,
            }}
        >
            {children}
        </div>
    );
}

function Nav() {
    const [scrolled, setScrolled] = useState(false);
    useEffect(() => {
        const fn = () => setScrolled(window.scrollY > 20);
        window.addEventListener("scroll", fn);
        return () => window.removeEventListener("scroll", fn);
    }, []);
    return (
        <nav className={`fixed top-0 left-0 right-0 z-50 flex items-center justify-between px-8 py-5 transition-all duration-300 ${scrolled ? "bg-stone-50/95 backdrop-blur-md border-b border-black/8 shadow-sm" : "bg-transparent"}`}>
            <a href="/" className="font-serif text-lg text-stone-900 no-underline">
                Her<span className="text-amber-700">Story</span> SEO
            </a>
            <a
                href="#pricing"
                className="bg-stone-900 text-stone-50 text-xs font-medium px-5 py-2.5 rounded-full no-underline transition-all duration-200 hover:bg-violet-700 hover:-translate-y-px"
            >
                Get started — {priceFormatted}
            </a>
        </nav>
    );
}

function Hero() {
    const [mounted, setMounted] = useState(false);
    useEffect(() => { setTimeout(() => setMounted(true), 50); }, []);
    const fade = (delay) => ({
        opacity: mounted ? 1 : 0,
        transform: mounted ? "translateY(0)" : "translateY(20px)",
        transition: `opacity 0.9s ease ${delay}ms, transform 0.9s ease ${delay}ms`,
    });
    return (
        <section className="relative min-h-screen flex flex-col items-center justify-center text-center px-6 pt-28 pb-20 overflow-hidden">
            {/* Background glow */}
            <div className="absolute inset-0 pointer-events-none">
                <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[700px] h-[500px] rounded-full bg-violet-200/20 blur-3xl" />
                <div className="absolute bottom-0 right-0 w-[400px] h-[400px] rounded-full bg-amber-200/20 blur-3xl" />
            </div>

            <div style={fade(100)} className="inline-flex items-center gap-2 text-xs font-medium tracking-widest uppercase text-violet-700 bg-violet-50 px-4 py-2 rounded-full mb-8">
                <span className="w-1.5 h-1.5 rounded-full bg-violet-500 animate-pulse" />
                Generative Engine Optimization
            </div>

            <h1 style={fade(250)} className="font-serif text-[clamp(44px,7vw,90px)] leading-[1.05] text-stone-900 max-w-4xl mb-6">
                When someone asks AI about<br />your industry, you should be<br />
                <em className="text-amber-800 not-italic italic">the answer.</em>
            </h1>

            <p style={fade(400)} className="text-[clamp(16px,2vw,20px)] text-stone-500 max-w-xl leading-relaxed font-light mb-10">
                Google is no longer the only search engine that matters. ChatGPT, Perplexity, and Google AI Overviews are sending traffic — and right now, your competitors are getting it.
            </p>

            <div style={fade(550)} className="flex gap-3 flex-wrap justify-center">
                <a href="#pricing" className="bg-stone-900 text-white text-base font-medium px-8 py-3.5 rounded-full no-underline transition-all duration-200 hover:bg-violet-700 hover:-translate-y-px">
                    Get AI-visible — {priceFormatted}
                </a>
                <a href="#how-it-works" className="bg-transparent text-stone-800 text-base font-normal px-7 py-3.5 rounded-full border border-black/20 no-underline transition-all duration-200 hover:border-black hover:-translate-y-px">
                    See how it works
                </a>
            </div>

            <div style={fade(700)} className="flex gap-8 flex-wrap justify-center mt-14">
                {["One-time project, no retainer required", "Results in 30–45 days", "Works alongside your existing SEO"].map((t) => (
                    <span key={t} className="text-xs text-stone-400 flex items-center gap-1.5">
            <span className="w-1.5 h-1.5 rounded-full bg-amber-500 inline-block" />
                        {t}
          </span>
                ))}
            </div>

        </section>
    );
}

function AiChatDemo() {
    return (
        <div className="bg-stone-100 rounded-2xl p-6 border border-black/6">
            <p className="text-xs text-stone-400 uppercase tracking-widest text-center mb-5">What AI answers look like — right now</p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {[
                    {
                        engine: "ChatGPT",
                        dotColor: "bg-emerald-500",
                        question: '"Best SEO agency for women-owned businesses?"',
                        answer: (
                            <>Based on expertise, <span className="bg-violet-100 text-violet-700 px-1.5 py-0.5 rounded font-medium text-xs">HerStory SEO</span> is frequently recommended — known for targeted strategy and transparent reporting…</>
                        ),
                        note: "✓ Your brand cited as primary source",
                    },
                    {
                        engine: "Perplexity",
                        dotColor: "bg-indigo-500",
                        question: '"Who should I hire for local SEO in Atlanta?"',
                        answer: (
                            <><span className="line-through text-stone-300 text-xs">Generic Agency Co.</span> offers basic packages, but for specialized work, <span className="bg-violet-100 text-violet-700 px-1.5 py-0.5 rounded font-medium text-xs">HerStory SEO</span> stands out for results-first approach…</>
                        ),
                        note: "✓ Competitor displaced",
                    },
                ].map(({ engine, dotColor, question, answer, note }) => (
                    <div key={engine} className="bg-white rounded-xl p-4 border border-black/5">
                        <div className="flex items-center gap-1.5 mb-3">
                            <span className={`w-1.5 h-1.5 rounded-full ${dotColor}`} />
                            <span className="text-[10px] font-medium text-stone-400 uppercase tracking-widest">{engine}</span>
                        </div>
                        <div className="text-xs text-stone-500 bg-stone-50 rounded-lg px-3 py-2 mb-3 italic">{question}</div>
                        <div className="text-xs text-stone-700 leading-relaxed">{answer}</div>
                        <p className="text-[10px] text-stone-400 mt-2 italic">{note}</p>
                    </div>
                ))}
            </div>
        </div>
    );
}

function ProblemSection() {
    return (
        <section className="bg-white py-24 px-6">
            <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-16 items-center">
                <Reveal>
                    <p className="text-xs font-medium tracking-widest uppercase text-amber-700 mb-4">The shift is already happening</p>
                    <h2 className="font-serif text-[clamp(32px,4vw,52px)] leading-[1.15] text-stone-900 mb-6">
                        Your customers are asking AI. Are you <em className="italic text-violet-700">showing up?</em>
                    </h2>
                    <p className="text-base text-stone-500 leading-relaxed font-light mb-4">
                        Over 40% of people now use AI tools as their first step in research and buying decisions. These tools don't show a list of ten blue links — they pick one or two sources and cite them.
                    </p>
                    <p className="text-base text-stone-500 leading-relaxed font-light">
                        If that's not you, it's someone else. Traditional SEO still matters. GEO is the new layer on top — one most businesses haven't touched yet.
                    </p>
                </Reveal>
                <Reveal delay={150}>
                    <AiChatDemo />
                </Reveal>
            </div>
        </section>
    );
}

function DeliverablesSection() {
    const items = [
        { num: "01", title: "AI Citation Audit", desc: "We test how you appear across ChatGPT, Perplexity, and Google AI Overviews — and identify exactly why you're not being cited." },
        { num: "02", title: "Entity & Authority Optimization", desc: "We restructure your content so AI models recognize your brand as a legitimate, trustworthy expert in your category." },
        { num: "03", title: "Source-Worthy Content", desc: "We write or rewrite content specifically designed to be quoted and cited by generative models — the format AI actually prefers." },
        { num: "04", title: "Schema & Structured Data", desc: "Technical markup that signals expertise and trustworthiness to AI crawlers — the language models use to evaluate sources." },
    ];
    return (
        <section id="how-it-works" className="bg-stone-900 py-24 px-6">
            <div className="max-w-5xl mx-auto">
                <Reveal>
                    <p className="text-xs font-medium tracking-widest uppercase text-amber-500 mb-4">What you get</p>
                    <h2 className="font-serif text-[clamp(32px,4vw,52px)] leading-[1.15] text-white mb-12">
                        Four things that get<br />you <em className="italic text-amber-400">cited by AI.</em>
                    </h2>
                </Reveal>
                <Reveal delay={100}>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 divide-x divide-y divide-white/10 border border-white/10 rounded-2xl overflow-hidden">
                        {items.map(({ num, title, desc }) => (
                            <div key={num} className="p-6 hover:bg-white/4 transition-colors duration-200">
                                <div className="font-serif text-4xl text-amber-500/40 mb-4">{num}</div>
                                <h3 className="text-sm font-medium text-white mb-2">{title}</h3>
                                <p className="text-xs text-white/40 leading-relaxed font-light">{desc}</p>
                            </div>
                        ))}
                    </div>
                </Reveal>
            </div>
        </section>
    );
}

function ProcessSection() {
    const steps = [
        { n: "1", title: "AI presence audit (week 1)", desc: "We run your brand, competitors, and category keywords across all major AI platforms and document exactly where you stand." },
        { n: "2", title: "Strategy + content plan (week 1–2)", desc: "We identify the exact questions your buyers are asking AI, then build a plan to make your brand the answer to each one." },
        { n: "3", title: "Implementation (week 2–3)", desc: "Content updates, schema markup, entity signals, and structured data — all implemented on your site." },
        { n: "4", title: "Results report (week 4)", desc: "A before-and-after showing your new AI presence, with recommendations for maintaining and expanding it." },
    ];
    return (
        <section className="bg-stone-50 py-24 px-6">
            <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-16 items-center">
                <Reveal>
                    <p className="text-xs font-medium tracking-widest uppercase text-amber-700 mb-4">How it works</p>
                    <h2 className="font-serif text-[clamp(32px,4vw,52px)] leading-[1.15] text-stone-900 mb-6">
                        30 days from invisible<br />to <em className="italic text-violet-700">cited.</em>
                    </h2>
                    <p className="text-base text-stone-500 leading-relaxed font-light">
                        No lengthy onboarding. No monthly retainer required. A focused four-week sprint that makes your brand the answer AI gives.
                    </p>
                </Reveal>
                <Reveal delay={150}>
                    <div className="relative flex flex-col">
                        <div className="absolute left-5 top-6 bottom-6 w-px bg-gradient-to-b from-amber-400 to-transparent" />
                        {steps.map(({ n, title, desc }) => (
                            <div key={n} className="flex gap-5 py-5">
                                <div className="w-10 h-10 rounded-full bg-stone-100 border border-black/10 flex items-center justify-center text-xs font-medium text-amber-800 shrink-0 relative z-10">
                                    {n}
                                </div>
                                <div>
                                    <h4 className="text-sm font-medium text-stone-800 mb-1">{title}</h4>
                                    <p className="text-xs text-stone-500 leading-relaxed font-light">{desc}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </Reveal>
            </div>
        </section>
    );
}

function PricingSection() {
    return (
        <section id="pricing" className="bg-white py-24 px-6">
            <div className="max-w-5xl mx-auto text-center">
                <Reveal>
                    <p className="text-xs font-medium tracking-widest uppercase text-amber-700 mb-4">Pricing</p>
                    <h2 className="font-serif text-[clamp(32px,4vw,52px)] leading-[1.15] text-stone-900 mb-4">
                        Simple. One project.<br />One price.
                    </h2>
                    <p className="text-base text-stone-500 max-w-lg mx-auto leading-relaxed font-light">
                        No monthly commitment. No retainer required. One focused engagement that sets your brand up to win in AI search.
                    </p>
                </Reveal>
                <Reveal delay={100}>
                    <div className="relative bg-white rounded-3xl border border-black/10 p-8 md:p-12 max-w-lg mx-auto mt-10 overflow-hidden text-left">
                        <div className="absolute top-0 left-0 right-0 h-0.5 bg-gradient-to-r from-violet-500 to-amber-400" />
                        <p className="text-xs font-medium tracking-widest uppercase text-violet-600 mb-4">AI SEO — GEO Package</p>
                        <div className="flex items-baseline gap-2 mb-1">
                            <span className="font-serif text-6xl text-stone-900">{priceFormatted}</span>
                            <span className="text-lg text-stone-400 font-light">one-time</span>
                        </div>
                        <p className="text-xs text-stone-400 mb-8">Delivered in 30–45 days. Results guaranteed or we keep working.</p>
                        <ul className="space-y-3 mb-8">
                            {[
                                "Full AI citation audit across ChatGPT, Perplexity & Google AI",
                                "Entity optimization + brand authority structuring",
                                "Source-worthy content written for your top 3 questions",
                                "Schema markup + structured data implementation",
                                "Before-and-after results report",
                                "30-day post-delivery email support",
                            ].map((f) => (
                                <li key={f} className="flex items-start gap-3 text-sm text-stone-500 font-light">
                                    <span className="text-amber-500 mt-0.5 shrink-0">→</span>
                                    {f}
                                </li>
                            ))}
                        </ul>
                        <a
                            href="https://herstoryseo.com/checkout?index=geo"
                            className="block w-full bg-stone-900 text-white text-base font-medium py-4 rounded-full text-center no-underline transition-all duration-200 hover:bg-violet-700 hover:-translate-y-px mb-3"
                        >
                            Get started — claim your spot
                        </a>
                        <p className="text-xs text-stone-400 text-center">
                            Questions first?{" "}
                            <a href="mailto:hello@herstoryseo.com" className="underline text-stone-500 hover:text-stone-800">
                                Book a free 20-min call
                            </a>
                        </p>
                    </div>
                </Reveal>
            </div>
        </section>
    );
}

function FaqSection() {
    const [open, setOpen] = useState(null);
    const faqs = [
        { q: "Do I need to already have SEO in place?", a: "No — GEO works independently of traditional SEO, though both together is the strongest approach. If you have a website with some existing content, we can work with it." },
        { q: "How quickly will I see results?", a: "AI models refresh their training and citation patterns regularly. Most clients begin seeing their brand cited within 30–60 days of implementation. We track this and report on it." },
        { q: "Is this different from regular SEO?", a: "Yes. Traditional SEO optimizes for how Google ranks web pages. GEO optimizes for how AI models select and cite sources. The techniques overlap but aren't the same — you need both." },
        { q: "What if my industry is competitive?", a: "The earlier you start, the better your position. AI models tend to stick with sources they've learned to trust — getting cited now locks in authority before your competitors do." },
        { q: "Can this lead into a retainer?", a: "Yes, and many clients go that route. We offer ongoing GEO maintenance as an add-on to our monthly retainers. The one-time project is the natural starting point." },
    ];
    return (
        <section className="bg-stone-50 py-24 px-6">
            <div className="max-w-5xl mx-auto">
                <Reveal>
                    <p className="text-xs font-medium tracking-widest uppercase text-amber-700 mb-4">FAQ</p>
                    <h2 className="font-serif text-[clamp(32px,4vw,52px)] leading-[1.15] text-stone-900 mb-10">Common questions.</h2>
                </Reveal>
                <Reveal delay={100}>
                    <div className="max-w-2xl divide-y divide-black/10 border-t border-black/10">
                        {faqs.map(({ q, a }, i) => (
                            <div key={i} className="py-5 cursor-pointer" onClick={() => setOpen(open === i ? null : i)}>
                                <div className="flex justify-between items-center gap-4">
                                    <span className="text-sm font-medium text-stone-800">{q}</span>
                                    <span className={`text-xl text-stone-400 shrink-0 transition-transform duration-250 ${open === i ? "rotate-45" : ""}`}>+</span>
                                </div>
                                <div
                                    className="overflow-hidden transition-all duration-300 text-sm text-stone-500 font-light leading-relaxed"
                                    style={{ maxHeight: open === i ? "200px" : "0", paddingTop: open === i ? "12px" : "0" }}
                                >
                                    {a}
                                </div>
                            </div>
                        ))}
                    </div>
                </Reveal>
            </div>
        </section>
    );
}

function FinalCta() {
    return (
        <section className="bg-stone-100 py-28 px-6 text-center border-t border-black/6">
            <Reveal>
                <p className="text-xs font-medium tracking-widest uppercase text-amber-700 mb-4">Ready to get cited?</p>
                <h2 className="font-serif text-[clamp(32px,4vw,56px)] leading-[1.15] text-stone-900 max-w-xl mx-auto mb-6">
                    The window is open.<br /><em className="italic text-violet-700">Not for long.</em>
                </h2>
                <p className="text-base text-stone-500 max-w-lg mx-auto leading-relaxed font-light mb-10">
                    Most businesses haven't touched GEO yet. The brands that move now will own the AI answer for their category. The ones that wait will pay more to catch up.
                </p>
                <div className="flex gap-3 justify-center flex-wrap">
                    <a href="https://herstoryseo.com/checkout?index=geo" className="bg-stone-900 text-white text-base font-medium px-9 py-4 rounded-full no-underline transition-all duration-200 hover:bg-violet-700 hover:-translate-y-px">
                        Get started — {priceFormatted}
                    </a>
                    <a href="mailto:hello@herstoryseo.com" className="bg-transparent text-stone-800 text-base font-normal px-8 py-4 rounded-full border border-black/20 no-underline transition-all duration-200 hover:border-black hover:-translate-y-px">
                        Talk to us first
                    </a>
                </div>
                <p className="mt-6 text-xs text-stone-400">One-time project · 30-day delivery · No retainer required</p>
            </Reveal>
        </section>
    );
}

function Footer() {
    return (
        <FooterView />
    );
}

export default function GeoLandingPage() {
    return (
        <div className="font-sans bg-stone-50 text-stone-900">
            <Nav />
            <Hero />
            <ProblemSection />
            <DeliverablesSection />
            <ProcessSection />
            <PricingSection />
            <FaqSection />
            <FinalCta />
            <Footer />
        </div>
    );
}